export enum IncomeClassificationCategoryType {
category1_1,
category1_2,
category1_3,
category1_4,
category1_5,
category1_6,
category1_7,
category1_8,
category1_9,
category1_10,
category1_95,
}
